<template>
	<div class="feedback">
		<div class="feedback-message-wrap">
			<div class="close" @click="closeClick"></div>
			<div class="title">意见反馈</div>
			<div class="text-head text-head2">反馈内容：</div>
			<div class="textarea-wrap">
				<textarea
					class="advice-content"
					:class="{
						'advice-content-active': isTextareaActive,
					}"
					maxlength="160"
					v-model="content"
					@focus="textareaFocus"
					placeholder="请简单描述您要反馈的问题或建议"
				></textarea>
			</div>
			<div v-if="uploadResult.length != 0" class="thumbnail-wrap">
				<div
					v-for="(item, index) in uploadResult"
					:key="index"
					class="thumbnail"
				>
					<img :src="item.file_url" alt="#" />
					<div
						class="delete-btn"
						@click="deleteThumbnailClick(index)"
					></div>
				</div>
			</div>
			<div class="file-wrap">
				<input
					type="file"
					accept="image/*"
					ref="fileInput"
					@change="uploadFileClick"
				/>
			</div>
			<div class="confirm-btn" @click="feedbackClick">提交</div>
			<Tip v-if="tip" :tip="tip"></Tip>
		</div>
	</div>
</template>

<script>
import Tip from "@/components/Tip.vue";
import { mapActions } from "vuex";
import "../../../node_modules/animate.css/animate.css";

export default {
	components: {
		Tip,
	},
	data: function () {
		return {
			content: "",
			isTextareaActive: false,
			uploadResult: [],
			tip: "",
		};
	},
	methods: {
		...mapActions(["userFile", "feedback"]),
		closeClick: function () {
			let _that = this;
			_that.$emit("closeFeedbackClick");
		},

		textareaFocus: function () {
			let _that = this;
			_that.isTextareaActive = true;
		},
		deleteThumbnailClick: function (index) {
			let _that = this;
			_that.uploadResult.splice(index, 1);
		},
		uploadFileClick: function () {
			let _that = this;
			let file = _that.$refs.fileInput.files[0];
			let formData = new window.FormData();
			formData.append("file", file);

			_that.userFile([
				formData,
				function (err, data) {
					if (data && data.rtn == 0) {
						if (data.data) {
							let fileItem = {
								file_id: data.data.file_id,
								file_url: data.data.file_url,
							};
							_that.uploadResult.push(fileItem);

							_that.tip = "上传成功";
							setTimeout(function () {
								_that.tip = "";
							}, 1500);
						}
					}
				},
			]);
		},
		feedbackClick: function () {
			let _that = this;
			if (_that.content) {
				let img_ids = [];
				for (
					let index = 0;
					index < _that.uploadResult.length;
					index++
				) {
					img_ids.push(_that.uploadResult[index].file_id);
				}
				_that.feedback([
					_that.content,
					img_ids,
					1,
					function (err, data) {
						if (data && data.rtn == 0) {
							_that.tip = "提交成功";
							setTimeout(function () {
								_that.tip = "";

								_that.closeClick();
							}, 1500);
						}
					},
				]);
			} else {
				_that.tip = "请填写内容";
				setTimeout(function () {
					_that.tip = "";
				}, 1500);
			}
		},
	},
};
</script>

<style scoped lang="less">
.feedback {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
	height: 100%;
	width: 100%;
	background: rgba(0, 0, 0, 0.5);
	font-size: 12px;
	color: #666666;

	.bg {
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	.close {
		position: absolute;
		z-index: 1;
		top: 10px;
		right: 10px;
		width: 20px;
		height: 20px;
		padding: 1px;
		.bg();
		background-image: url("../../assets/common/close4.svg");
		cursor: pointer;
	}

	.feedback-message-wrap {
		position: absolute;
		padding-top: 1px;
		padding-left: 48px;
		padding-right: 48px;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 615px;
		height: 400px;
		border-radius: 7px;
		box-sizing: border-box;
		background-color: #fcfcfc;

		.title {
			margin-top: 13px;
			text-align: center;
			font-size: 17px;
			font-weight: 700;
			color: #1a1a1a;
		}
		.text-head {
			margin-top: 30px;
			font-size: 14px;
			font-weight: 700;
			color: #1a1a1a;
		}

		.text-head2 {
			margin-top: 20px;
		}

		.textarea-wrap {
			margin-top: 10px;
			position: relative;
			width: 100%;
			height: 125px;
			.advice-content {
				padding: 20px;
				padding-top: 18px;
				padding-bottom: 30px;
				height: 100%;
				box-sizing: border-box;
				background-color: #f2f5fd;
				width: 100%;
				resize: none;
				border-radius: 3px;
				color: #666666;
				line-height: 20px;
				overflow: hidden;
				border: 1px solid #f2f5fd;
				font-size: 14px;
			}
			.advice-content-active {
				background-color: #fcfdff;
				border: 1px solid #ebeef5;
			}
			textarea::-webkit-input-placeholder {
				/* WebKit, Blink, Edge */
				color: #999999;
				font-size: 14px;
			}

			:-moz-placeholder {
				/* Mozilla Firefox 4 to 18 */
				color: #999999;
				font-size: 14px;
			}

			::-moz-placeholder {
				/* Mozilla Firefox 19+ */
				color: #999999;
				font-size: 14px;
			}

			input:-ms-input-placeholder {
				/* Internet Explorer 10-11 */
				color: #999999;
				font-size: 14px;
			}

			input::-ms-input-placeholder {
				/* Microsoft Edge */
				color: #999999;
				font-size: 14px;
			}
		}
		.thumbnail-wrap {
			margin-top: 10px;
			display: inline-block;
			vertical-align: top;
			.thumbnail {
				position: relative;
				display: inline-block;
				margin-right: 10px;
				vertical-align: top;
				width: 58px;
				height: 41px;
				box-sizing: border-box;
				border: 1px solid #e6e6e6;

				img {
					width: 100%;
					height: 100%;
				}

				.delete-btn {
					position: absolute;
					right: -8px;
					top: -8px;
					width: 17px;
					height: 17px;
					.bg();
					background-image: url("../../assets/userinfo/c10.svg");
					cursor: pointer;
				}
			}
		}
		.file-wrap {
			margin-top: 10px;
			display: inline-block;
			vertical-align: top;
			position: relative;
			padding-left: 38px;
			width: 58px;
			height: 41px;
			background-color: #e6e6e6;
			box-sizing: border-box;
			border-radius: 2px;
			overflow: hidden;
			font-size: 14px;

			input {
				position: absolute;
				top: 0;
				right: 0;
				height: 100%;
				cursor: pointer;
				opacity: 0;
				background-color: transparent;
				color: transparent;
			}
		}
		.file-wrap::before {
			content: "";
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 20px;
			height: 20px;
			.bg();
			background-image: url("../../assets/userinfo/a5.svg");
		}

		.confirm-btn {
			margin: 0 auto;
			margin-top: 30px;
			width: 112px;
			height: 36px;
			line-height: 36px;
			text-align: center;
			border-radius: 58px;
			background-color: #1f5de3;
			color: #ffffff;
			font-size: 14px;
			font-weight: 700;
			cursor: pointer;
		}
	}
}
</style>
